export const PageStyles = (theme) => ({
  filterDiv: {
    display: "flex",
    gap: 3,
    mb: 3,
  },

  InputField: {
    background: "#f8f9fa",
    borderRadius: 1,
    px: 1,
    minWidth: 180,
    fontSize: 14,
  },

  selectField: {
    background: "#f8f9fa",
    borderRadius: 1,
    px: 1,
    minWidth: 150,
    "& .MuiOutlinedInput-notchedOutline": {
      border: "none",
    },
  },

  InputField2: {
    minWidth: 240,
    backgroundColor: "#f8f9fa",
    borderRadius: 1,
    border: "0px solid #ddd",
  },

  teamListDiv: {
    // border: `1px solid ${theme.palette.border.thin}`,
    borderRadius: 1.6,
  },

  accordianDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    p: 2,
    border: `1px solid ${theme.palette.border.thin}`,
    borderRadius: "8px",
    marginBottom: 1,
    cursor: "pointer",
    "&:hover": { bgcolor: "action.hover" },
  },

  online: {
    color: "#016630",
    fontSize: "0.75rem",
    background: "#dcfce7",
    padding: "1.5px 10px",
    borderRadius: "4px",
  },

  offline: {
    color: "#1e2939",
    fontSize: "0.75rem",
    background: "#f3f4f6",
    padding: "1.5px 10px",
    borderRadius: "4px",
  },

  collapseDiv: {
    borderTop: "none",
    borderColor: "divider",
    p: 2,
    border: `1px solid ${theme.palette.border.thin}`,
    borderRadius: "0px 0px 8px 8px",
  },

  teamDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    py: 0.5,
  },

  online1: {
    background: "#00c951",
    padding: "1.5px 10px",
    borderRadius: "4px",
    fontSize: "0.75rem",
    color: "#016630",
  },

  offline1: {
    color: "#1e2939",
    fontSize: "0.75rem",
    background: "#f3f4f6",
    padding: "1.5px 10px",
    borderRadius: "4px",
  },

  driverDiv: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid",
    borderColor: "#e0dddc",
    borderRadius: 1,
    p: 1.5,
  },

  mapDiv: {
    height: 400,
    borderRadius: 2,
    bgcolor: "grey.100",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    textAlign: "center",
  },

  forgotRootDiv: {
    minHeight: "100vh",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "#fafafa",
    p: 2,
  },

  forgotcard: {
    width: { xs: "92%", sm: 460 },
    borderRadius: 2,
    overflow: "visible",
    position: "relative",
  },

  lightTextSmall: {
    color: theme.palette.text.secondary,
    fontSize: theme.palette.textSize.sm,
  },

  lightTextSmall1: {
    color: theme.palette.text.secondary,
    fontWeight: 400,
    fontSize: "14px",
  },

  lightTextMedium: {
    color: theme.palette.text.secondary,
    fontWeight: 500,
    fontSize: theme.palette.textSize.md,
  },

  darkTextSmall: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: theme.palette.textSize.xs,
  },

  darkTextMedium: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: theme.palette.textSize.md,
  },

  darkTextlg: {
    color: theme.palette.text.primary,
    fontWeight: 600,
    fontSize: theme.palette.textSize.lg,
  },

  darkTextMedium1: {
    color: theme.palette.text.primary,
    fontWeight: 500,
    fontSize: "24px",
  },

  successToast: {
    background: "#FFFCF0",
    color: "#DC7609",
    border: "1px solid #DC7609",
    position: "relative",
  },

  flex_row: {
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between",
  },

  flex_between: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
  },

  flex_around: {
    display: "flex",
    justifyContent: "space-around",
    alignItems: "center",
  },

  flex_c: {
    display: "flex",
    alignItems: "center",
    gap: 1,
  },

  flex_cen_column: {
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
  },

  flex_cen_column1: {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
  },

  flex_center: {
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
  },

  flex_end:{
    display: "flex",
    alignItems: "center",
    justifyContent: "flex-end",
  },

  themeBtn: {
    background: theme.palette.primary.main,
  },

  empChip: {
    px: 1,
    py: 0.5,
    borderRadius: "8px",
    backgroundColor: theme.palette.primary.main,
    color: theme.palette.text.white,
    fontSize: theme.palette.textSize.sm,
    fontWeight: 500,
  },

  freeChip: {
    px: 1,
    py: 0.5,
    borderRadius: "8px",
    backgroundColor: "#90caf9",
    color: "#000",
    fontSize: theme.palette.textSize.sm,
    fontWeight: 500,
  },

  inputLabel: {
    color: theme.palette.text.primary,
    fontSize: theme.palette.textSize.xs,
    fontWeight: 500,
    mb: 0,
  },

  inputField: {
    mt: 0,
    backgroundColor: "#f3f3f5",
    borderRadius: "0.6rem",
    "& .MuiOutlinedInput-root": {
      borderRadius: "0.6rem",
      "& fieldset": {
        borderColor: "transparent",
        transition: "border-color 0.3s ease, box-shadow 0.3s ease",
      },
      "&:hover fieldset": {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 3px ${theme.palette.primary.main}`,
      },
      "&.Mui-focused fieldset": {
        borderColor: theme.palette.primary.main,
        boxShadow: `0 0 3px ${theme.palette.primary.main}`,
      },
    },
  },

  border_none: {
    border: "none",
  },

  uploadIcon: {
    width: 80,
    height: 80,
    borderRadius: "50%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    bgcolor: "grey.100",
    mr: 2,
  },

  cloudIcon: {
    fontSize: 36,
    color: "grey.500",
  },

  uploadDiv: {
    borderStyle: "dashed",
    textAlign: "center",
    p: 4,
    bgcolor: "grey.50",
    cursor: "pointer",
  },

  documentDiv: {
    p: 1.5,
    mb: 1,
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center",
    border: "1px solid #eee",
  },

  uploadImg: {
    width: "auto",
    height: "200px",
  },

  pdfImage: {
    width: "auto",
    height: "100px",
  },

  uploadBtn: {
    ml: 2,
    display: "block",
    margin: "auto",
    width: "fit-content",
    mt: 1,
  },

  toggleBtn: {
    mb: 3,
    borderBottom: "2px solid #f5f5f5",
    pb: 1,
    backgroundColor: "#f5f5f5",
    padding: 1,
    borderRadius: 3,
  },

  mapView: {
    height: 180,
    bgcolor: "#f9fafc",
    borderRadius: 2,
    border: `1px solid ${theme.palette.border.thin}`,
    position: "relative",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    fontSize: 14,
    color: "text.secondary",
  },

  mapCircle: {
    position: "absolute",
    top: 8,
    right: 8,
    bgcolor: "#ffe3b3",
    px: 1,
    borderRadius: 1,
    fontWeight: 500,
    fontSize: 12,
  },

  svgBox: {
    mt: 1,
    borderRadius: 1.5,
    border: "1px solid rgba(0,0,0,0.08)",
    overflow: "hidden",
    position: "relative",
  },

  overlayBox: {
    position: "absolute",
    left: 12,
    top: 12,
    bgcolor: "rgba(255,255,255,0.9)",
    px: 1,
    py: 0.4,
    borderRadius: 1,
    bosizehadow: 1,
    fontSize: 12,
    display: "flex",
    gap: 1,
    alignItems: "center",
  },

  geoList: {
    maxHeight: 220,
    overflowY: "auto",
    px: 0.5,
    "::-webkit-scrollbar": { width: 8 },
    "::-webkit-scrollbar-thumb": {
      background: "rgba(0,0,0,0.12)",
      borderRadius: 2,
    },
  },

  geoListItem: {
    py: 0.6,
    px: 1,
    display: "flex",
    alignItems: "center",
    gap: 1,
    borderRadius: 1,
    mb: 0.5,
  },

  geoDot: {
    width: 10,
    height: 10,
    borderRadius: "50%",
    ml: 0.5,
    mr: 1,
    flesizehrink: 0,
  },

  cardRoot: {
    borderRadius: 2,
    backgroundColor: "#faf9f7",
    boxShadow: "none",
    paddingBottom: 0,
    mb: 3,
  },

  buttonGroupConfig: {
    display: "flex",
    width: "100%",
    backgroundColor: "#f9f7f4",
    borderRadius: "8px",
    "& .MuiButton-root": {
      flex: 1,
      textTransform: "none",
      borderRadius: 0,
      fontWeight: 600,
      fontSize: "0.95rem",
      color: "text.secondary",
      display: "flex",
      alignItems: "center",
      justifyContent: "center",
      gap: 1,
      transition: "all 0.2s ease",
    },
    "& .MuiButton-root:hover": {
      backgroundColor: "transparent",
      color: "#111",
    },
    "& .MuiButton-root.Mui-selected": {
      backgroundColor: "white",
    },
  },

  simpleCard: {
    borderRadius: 1,
    border: `1px solid ${theme.palette.divider}`,
    boxShadow: "none",
  },

  teamtag: {
    backgroundColor: theme.palette.primary.main,
    p: 0.5,
    m: 0.2,
    borderRadius: 1,
    textAlign: "center",
    fontSize: theme.palette.textSize.xs,
    fontWeight: 500,
  },

  mapmainDiv: {
    position: "relative",
    border: `1px solid ${theme.palette.divider}`,
    borderRadius: "0.5rem",
  },

  mapTextField: {
    position: "absolute",
    top: "10px",
    left: "10px",
    zIndex: 9999,
    border: "1px solid #00000070",
  },

  toggleOptions: {
    borderRadius: 3,
    px: 2,
    width: "100%",
    fontWeight: 600,
  },

  tabSection: {
    display: "flex",
    gap: 2,
    justifyContent: "space-around",
    backgroundColor: "#f5f5f5",
    padding: "4px",
    marginX: 2,
    borderRadius: 3,
  },

  tabActive: {
    borderRadius: "20px",
    textTransform: "none",
    width: "100%",
    fontSize: theme.palette.textSize.xs,
    backgroundColor: theme.palette.primary.main,
    fontWeight: 600,
    border: "0px solid",
    color: theme.palette.primary.white,
  },

  tabInactive: {
    borderRadius: "20px",
    textTransform: "none",
    width: "100%",
    fontSize: theme.palette.textSize.xs,
    backgroundColor: "transparent",
    fontWeight: 600,
    border: "none",
    color: theme.palette.text.primary,
  },

  avilableStatus: {
    bgcolor: "#B8FFB880",
    color: "#004700",
    border: "1px solid #00470050",
  },

  notAvilableStatus: {
    bgcolor: "#D32F2F10",
    color: "#D32F2F",
    border: "1px solid #D32F2F50",
  },

  driverActive: {
    backgroundColor: theme.palette.primary.background50,
    border: `1px solid ${theme.palette.primary.main}`,
  },

  driverInactive: {
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.divider}`,
  },

  notifyDiv: {
    borderRadius: 1,
    border: "1px solid #ece9e2",
    marginBottom: 2,
    display: "flex",
    alignItems: "center",
    gap: 12,
    justifyContent: "space-between",
    padding: 2,
  },

  notifyDiv1: {
    position: "relative",
    padding: "14px 16px",
    borderRadius: 1,
    border: "1px solid #f0e7dd",
    marginBottom: 1,
    boxShadow: "0 0 0 1px rgba(0,0,0,0.01)",
    cursor: "pointer",
  },

  notifyMsg: {
    color: "#666",
    fontSize: 13,
    whiteSpace: "nowrap",
    overflow: "hidden",
    textOverflow: "ellipsis",
  },

  userIcon:{
    width: 30, 
    height: 30, 
    borderRadius: "50%", 
    overflow: "hidden", 
    backgroundColor: theme.palette.primary.main, 
    display: "flex", 
    alignItems: "center", 
    justifyContent: "center"
  },

  dividerClass:{
    my: 1, borderColor: "divider"
  },

  dispatcherCard:{
    borderRadius: 1,
    border: "1px solid #ece9e2",
    padding: 0,
    cursor: "pointer",
    transition: "all 0.3s ease-in-out",
    textAlign: "center",    
  }
});
